import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const DocumentFileFooterIcon = (props: IconProps) => (
  <Icon width="14px" height="20px" viewBox="0 0 14 20" {...props}>
    <path d="M11.012 20H3.044a2.913 2.913 0 0 1-2.1-.91 3.177 3.177 0 0 1-.871-2.19V3.305A3.384 3.384 0 0 1 1 .969 3.103 3.103 0 0 1 3.238 0h5.31c.159 0 .311.066.424.184a.641.641 0 0 1 .176.443v4.045c0 .045.018.088.049.12.03.032.072.05.116.05h3.872c.238 0 .466.1.634.276a.962.962 0 0 1 .263.662v11.024c0 .42-.08.837-.235 1.225a3.21 3.21 0 0 1-.666 1.037 3.057 3.057 0 0 1-.996.692 2.95 2.95 0 0 1-1.173.242ZM3.238.956a2.207 2.207 0 0 0-1.59.689 2.407 2.407 0 0 0-.66 1.66V16.9c.001.568.218 1.114.604 1.516.385.402.907.628 1.452.628h7.968c.569 0 1.114-.236 1.516-.657.403-.42.629-.989.63-1.583V5.798H9.312c-.286 0-.56-.119-.763-.33a1.153 1.153 0 0 1-.317-.796V.956H3.238Z" />
    <path d="m8.962.173-.64.683 4.856 4.954.64-.683L8.962.173Z" />
    <rect width="8.4" height="1" x="2.873" y="9.185" rx=".5" />
    <rect width="8.4" height="1" x="2.873" y="11.185" rx=".5" />
    <rect width="5.305" height="1" x="2.873" y="13.185" rx=".5" />
  </Icon>
);

export default memo(DocumentFileFooterIcon);
